// extracted by mini-css-extract-plugin
export default {"flash":"src-modules-errors-style__flash_11ntj","dismiss":"src-modules-errors-style__dismiss_h8OmO"};